var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from "mobx";
export class GlobalAdminAnalyticsManager {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.isLoadingCount = false;
        this.newPatientCount = null;
        this.errorMessage = null;
    }
    async loadNewPatientCount(input) {
        this.isLoadingCount = true;
        this.errorMessage = null;
        try {
            const count = await this.analyticsService.getNewPatientCount(input);
            this.newPatientCount = count;
            return count;
        }
        catch (error) {
            this.errorMessage = error instanceof Error ? error.message : "Failed to load new patient count";
            this.newPatientCount = null;
            return null;
        }
        finally {
            this.isLoadingCount = false;
        }
    }
    clearData() {
        this.newPatientCount = null;
        this.errorMessage = null;
    }
}
__decorate([
    observable
], GlobalAdminAnalyticsManager.prototype, "isLoadingCount", void 0);
__decorate([
    observable
], GlobalAdminAnalyticsManager.prototype, "newPatientCount", void 0);
__decorate([
    observable
], GlobalAdminAnalyticsManager.prototype, "errorMessage", void 0);
__decorate([
    action
], GlobalAdminAnalyticsManager.prototype, "loadNewPatientCount", null);
__decorate([
    action
], GlobalAdminAnalyticsManager.prototype, "clearData", null);
